import { PriceStyle } from '@/interface/enum';

export function calculateVoucherMaxPayout(voucherStake: number, price: number, priceStyle: PriceStyle) {
    if (priceStyle === PriceStyle.Unknown) {
        return 0;
    }

    const voucherActualStake = price < 0
        ? Math.abs(voucherStake * price)
        : voucherStake;
    return getMaxPayout(voucherStake, price, priceStyle) - voucherActualStake;
}

export function getMaxPayout(stake: number, price: number, priceStyle: PriceStyle) {
    if (priceStyle === PriceStyle.Unknown) {
        return 0;
    }

    if (stake === 0) {
        return 0;
    }

    let payout = 0;
    if (priceStyle === PriceStyle.Euro) {
        payout = stake * price;
    } else {
        payout = Math.abs(stake * price) + stake;
    }

    return payout;
}
